document.querySelectorAll('.carousel-section').forEach(function (section) {
  var sectionId = section.dataset.sectionId;
  var track    = document.getElementById('carousel-track-' + sectionId);
  var prevBtn  = document.getElementById('carousel-prev-' + sectionId);
  var nextBtn  = document.getElementById('carousel-next-' + sectionId);
  if (!track || !prevBtn || !nextBtn) return;

  var viewport = track.parentElement;
  var cards    = track.querySelectorAll('.carousel-card');
  var GAP      = 24;
  var currentIndex = 0;
  var cardWidth    = 0;  /* cached — only updated on recalculate() */

  function getVisible() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768)  return 2;
    return 1;
  }

  /* Reads layout once, writes card widths, caches result.
     Only called on load and resize — never during a slide transition. */
  function recalculate() {
    var visible   = getVisible();
    var totalGaps = (visible - 1) * GAP;
    /* Single read of offsetWidth, then batch-write all card widths */
    var vw = viewport.offsetWidth;
    cardWidth = (vw - totalGaps) / visible;
    cards.forEach(function (card) { card.style.width = cardWidth + 'px'; });
  }

  /* Writes transform only — no layout reads, safe to call on every click */
  function slide() {
    var visible  = getVisible();
    var maxIndex = Math.max(0, cards.length - visible);
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
    track.style.transform = 'translateX(-' + (currentIndex * (cardWidth + GAP)) + 'px)';
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= maxIndex;
  }

  nextBtn.addEventListener('click', function () { currentIndex++; slide(); });
  prevBtn.addEventListener('click', function () { currentIndex--; slide(); });

  /* Touch swipe */
  var startX = 0;
  track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      currentIndex += diff > 0 ? 1 : -1;
      slide();
    }
  });

  /* Debounced resize — recalculates card widths then re-slides to current index */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      currentIndex = 0;
      recalculate();
      slide();
    }, 150);
  });

  /* Initial setup after layout is painted */
  window.addEventListener('load', function () { recalculate(); slide(); });
  recalculate();
  slide();
});
